import React from 'react';
import { CardSubhead, CardTitle } from '@spark/ui-components/components/Card';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import styled from 'styled-components';

const ProgramacaoHavanHeader = ({
  totalRegistros,
  onMostrarAuditoriaGeral,
  actions
}) => (
  <HeaderContainer>
    <HeaderInfo>
      <TitleRow>
        <CardTitle className="mb-0">Agendamento</CardTitle>
        {onMostrarAuditoriaGeral ? (
          <Tooltip dir="top" text="Auditoria geral da programação">
            <HeaderIconButton type="button" onClick={onMostrarAuditoriaGeral} aria-label="Auditoria geral da programação">
              <Icon name="eye" size={16} />
            </HeaderIconButton>
          </Tooltip>
        ) : null}
      </TitleRow>
      <CardSubhead>Total de registros: {totalRegistros}</CardSubhead>
    </HeaderInfo>
    {actions ? <HeaderActions>{actions}</HeaderActions> : null}
  </HeaderContainer>
);

export default ProgramacaoHavanHeader;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 14px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const HeaderInfo = styled.div`
  min-width: 0;
`;

const TitleRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const HeaderIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 4px;
  cursor: pointer;
  color: #163455;

  &:focus-visible {
    outline: 2px solid #163455;
    outline-offset: 2px;
  }
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
  }
`;
